// extracted by mini-css-extract-plugin
export default {"content":"NMfBmCFufgUJYrY_DOIo","leftContainer":"zd8XtgwuE2vgvu5lfUBz","actions":"yDW52KRCPbohEtc31gDn","rightContainer":"mBsTvPkaqHBaPMIq0g6x","title":"myyOqGE0Pf9r9AVeFtlO"};